export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const STRIPE_TOKEN = process.env.REACT_APP_STRIPE_TOKEN;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const APP_URL= process.env.REACT_APP_BASE_URL;